import { render, staticRenderFns } from "./DrawLottery.vue?vue&type=template&id=2cade35b&scoped=true"
import script from "./DrawLottery.vue?vue&type=script&lang=js"
export * from "./DrawLottery.vue?vue&type=script&lang=js"
import style0 from "./DrawLottery.vue?vue&type=style&index=0&id=2cade35b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cade35b",
  null
  
)

export default component.exports